import React, { useState, useEffect } from "react";
import "./index.scss";
import Loader from "../../reusableComponents/loader/Loader";
import LoadImage from "./loadImage";
import { connect } from 'react-redux'
import { countNonEmptyKeysExcluding } from "../../reusableComponents/commonFunctions/commonFunctions";
import Locktext from "./locktext";
import LockIcon from '../../../../../asset/lock.png'

const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Handle missing dates

    const date = new Date(dateString.includes("T") ? dateString : dateString + "T00:00:00Z"); // Fix Safari issue

    const formattedDate = isNaN(date.getTime())
        ? "Invalid Date"
        : date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

    return formattedDate;
};

const HuntOptions = (props) => {
    const [huntData, setHuntData] = useState(props.UnitData)
    const [spinLoader, setSpinLoader] = useState(true)
    const [countFilter, setCountFilter] = useState(0)

    useEffect(() => {
        setHuntData(props.fetchUnitData)
        props.UnitData && setSpinLoader(false)
        const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
        const count = countNonEmptyKeysExcluding(props.huntplannerMorefilters, excludeKeys);
        setCountFilter(count)
    }, [props.UnitData])

    useEffect(() => {
        const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
        const count = countNonEmptyKeysExcluding(props.huntplannerMorefilters, excludeKeys);
        setCountFilter(count)
    }, [props.huntplannerMorefilters])

    return (
        <div className="hunt-options">
            <div className="header" style={{ width: '100%' }}>
                <span className="hunt-options-count">Hunt Options <span className="count">({props.UnitData?.hunts?.length ?? 0})</span></span>
            </div>

            {props.UnitData && props.UnitData.hunts && props.UnitData.hunts.map((option) => {
                let drawodds = option.minPoint && JSON.parse(option.minPoint)
                return (
                    <div key={option.webHuntId} className="card" style={{ width: '100%' }} onClick={() => props.onCLickOnHuntsItems(option)}>
                        <div className="ut-ht-options-container-one">
                            <div className="one">
                                <p className="date oswald-bold">
                                    {`${formatDate(option?.startDate)} - ${formatDate(option?.endDate)}`}
                                </p>
                                <div style={{ display: 'flex', marginTop: 5 }}>
                                    <p className="oswald-medium" style={{ color: '#1D1D1D' }}>Sex : </p>
                                    <p className={`either ${option.sex == 'female' ? 'red' : 'orange'}`}> {option.sex}</p>
                                </div>
                            </div>

                            <div className="two">
                                <LoadImage imageProfileUrl={option.weaponIconUrl} defaultImage={'../../asset/defaultweaponicon.png'}></LoadImage>
                            </div>
                        </div>

                        <div className="ut-ht-options-container-two">
                            <div className="unit-metrics important-width"
                            //  style={{ width: '350px !important' }}
                            >
                                <div className="stat" style={{ width: '25%', fontSize: '1.2em' }}>
                                    <Locktext
                                        LockIcon={LockIcon}
                                        text={drawodds?.point}
                                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                                        textClass='green'
                                        className={'font-style-oswald-medium'}
                                        height='30px'
                                    />
                                    {/* <div className="progress">
                                        <div
                                            className={`progress-bar  ${drawodds?.point <= 33 ? 'red' : drawodds?.point <= 66 ? 'yellow' : 'green'}`}
                                            style={{ width: `${drawodds?.point ?? 0}%` }}
                                        ></div>
                                    </div> */}
                                    <p className="label">Min Pts <br></br>to draw</p >
                                </div>

                                {/* <div className="partition-line"></div> */}

                                <div className="stat" style={{ width: '25%', fontSize: '1.2em' }} >
                                    <Locktext
                                        LockIcon={LockIcon}
                                        text={(drawodds?.odds ? drawodds?.odds.toFixed(0) : "-")}
                                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                                        showColorText={true}
                                        showPercentage={true}
                                        className={'font-style-oswald-medium'}
                                        height='30px'
                                    />

                                    {/* <div className="progress">
                                        <div
                                            className={`progress-bar ${drawodds?.odds <= 33 ? 'red' : drawodds?.odds <= 66 ? 'yellow' : 'green'}`}
                                            style={{ width: `${drawodds?.odds ?? 0}%` }}
                                        ></div>
                                    </div> */}

                                    <p className="label">Draw odds 1st choice</p>
                                </div>

                                {/* <div className="partition-line"></div> */}

                                <div className="stat" style={{ width: '25%', fontSize: '1.2em' }}>
                                    {/* <div className='stat' style={{ width: '100%', height: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span className={`metric-value font-style-oswald-medium ${option?.harvestSuccess <= 33 ? 'red' : option?.harvestSuccess <= 66 ? 'yellow' : !option?.harvestSuccess ? 'grey' : 'green'}`}>
                                            {option?.harvestSuccess !== undefined ? `${option?.harvestSuccess.toFixed(0)}%` : "-"}
                                        </span>
                                    </div> */}
                                    <Locktext
                                        LockIcon={LockIcon}
                                        text={(option?.harvestSuccess ? option?.harvestSuccess.toFixed(0) : "-")}
                                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                                        showColorText={true}
                                        showPercentage={true}
                                        className={'font-style-oswald-medium'}
                                        height='30px'
                                    />

                                    {/* <div className="progress">
                                        <div
                                            className={`progress-bar ${option.harvestSuccess <= 33 ? 'red' : option.harvestSuccess <= 66 ? 'yellow' : 'green'}`}
                                            style={{ width: `${option.harvestSuccess ?? 0}%` }}
                                        ></div>
                                    </div> */}
                                    <p className="label">Harvest success</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}

        </div>
    );
};

const mapStateToProps = state => ({
    huntplannerMorefilters: state.huntplannerMorefilters,
    huntPlannerFilterOptions: state.huntPlannerFilterOptions
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(HuntOptions)









